import { Platform } from '@mint-lib/routing-context';

import { Platform as PlatformType } from '../types/index.js';

export const getPlatformType = (integration: Platform) => {
  if (['publisher', 'ad_network'].includes(integration?.category)) {
    return 'media_ad_network_campaign';
  }
  return 'ghost_campaign';
};

export const transformPlatformsResponse = (
  integration: Platform,
): PlatformType => {
  return {
    ...integration,
    categoryType: getPlatformType(integration),
  };
};

export const getParsedGhostIds = () => {
  const storedIds = sessionStorage.getItem('integratedGhostIds');
  return storedIds ? JSON.parse(storedIds) : [];
};

export const setIntegratedGhostIds = (id: number) => {
  const parsedIds = getParsedGhostIds();
  if (!parsedIds.includes(id)) {
    parsedIds.push(id);
    sessionStorage.setItem('integratedGhostIds', JSON.stringify(parsedIds));
  }
};
export const isVirtualPlatformIntegrated = (integration: PlatformType) => {
  if (integration?.type !== 'virtual') {
    return false;
  }
  return getParsedGhostIds().includes(integration.id);
};
